export interface INoteHistoryItem {
    ID: number;
    NoteID: number;
    OriginalAdminID: number;
    Note: string;
    Sticky: boolean;
    AdminName: string;
    Created: Date;
}


export class NoteHistoryItemArray extends Array<NoteHistoryItem> {

    constructor(...items: NoteHistoryItem[]) {
        super(...items);
        Object.setPrototypeOf(this, NoteHistoryItemArray.prototype);
    }

    public static FixDates(items: NoteHistoryItemArray) {

        if (items == null || items.length == 0)
            return;

        items.forEach((item) => {
            NoteHistoryItem.FixDate(item);
        });
    }

}

export class NoteHistoryItem implements INoteHistoryItem {
    ID: number;
    NoteID: number;
    OriginalAdminID: number;
    Note: string;
    Sticky: boolean;
    AdminName: string;
    Created: Date;

    public static FixDate(item: NoteHistoryItem) {

        if (item == null)
            return;

        item.Created = new Date(item.Created);
    }
}
